import { MouseEvent, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './MenuMobile.module.scss';
import { Text } from 'components/Text/Text';

type Props = {
  children: ReactNode;
  onClose(): void;
};

export const MenuMobile = ({ children, onClose }: Props) => {
  const container = document.getElementById('menu-mobile');
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (!container) return null;

  const onMenuClose = (e: MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <>
      {createPortal(
        <div className={styles.backdrop} onClick={onMenuClose}>
          <div className={styles.content}>
            {children}
            <div className={styles.cancel} onClick={onClose}>
              <Text type="body2">Cancel</Text>
            </div>
          </div>
        </div>,
        container,
      )}
    </>
  );
};
